var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 11.6667L6.25033 9.25008C6.38622 8.9802 6.59293 8.75233 6.84833 8.59087C7.10374 8.4294 7.39824 8.34041 7.70033 8.33341H16.667M16.667 8.33341C16.9216 8.33297 17.1729 8.39086 17.4017 8.50265C17.6304 8.61444 17.8305 8.77715 17.9866 8.9783C18.1427 9.17945 18.2507 9.41369 18.3022 9.66304C18.3536 9.91239 18.3473 10.1702 18.2837 10.4167L17.0003 15.4167C16.9075 15.7764 16.6972 16.0947 16.4028 16.3212C16.1084 16.5476 15.7467 16.6693 15.3753 16.6667H3.33366C2.89163 16.6667 2.46771 16.4912 2.15515 16.1786C1.84259 15.866 1.66699 15.4421 1.66699 15.0001V4.16675C1.66699 3.72472 1.84259 3.3008 2.15515 2.98824C2.46771 2.67567 2.89163 2.50008 3.33366 2.50008H6.58366C6.8624 2.49735 7.13737 2.56457 7.38341 2.6956C7.62945 2.82662 7.83869 3.01727 7.99199 3.25008L8.66699 4.25008C8.81875 4.48052 9.02535 4.66968 9.26824 4.80058C9.51114 4.93148 9.78274 5.00003 10.0587 5.00008H15.0003C15.4424 5.00008 15.8663 5.17567 16.1788 5.48824C16.4914 5.8008 16.667 6.22472 16.667 6.66675V8.33341Z",
    stroke: "#573B76",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8296638b449e45bf8ec661723cd166d9.svg";
export { ForwardRef as ReactComponent };